<dx-data-grid #grid>
   <dxo-header-filter [visible]="true"></dxo-header-filter>

   <!--      <dxi-column dataField="id" width="60" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="ID"></dxi-column>-->

   <dxi-column *ngIf="isModal" cellTemplate="addTemplate" caption="Aggiungi" width="100" alignment="center"></dxi-column>
   <div *dxTemplate="let cellInfo of 'addTemplate'">
      <button (click)="clickAddInstance(cellInfo.data)"
              class="btn-tbl btn-primary mt-3">
         <i class="fa-solid fa-plus"></i>
      </button>
   </div>

   <dxi-column caption="Storico Movimenti" cellTemplate="stampaTemplate" width="100" *ngIf="!isModal"></dxi-column>
   <div *dxTemplate="let cellInfo of 'stampaTemplate'">
      <button class="btn-tbl btn-primary ml-3"
              (click)="clickShowOrdiniFor(cellInfo.data)">
         <i class="fa-solid fa-list"></i>
      </button>
   </div>

   <dxi-column dataField="qta" width="60" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Qta"></dxi-column>
   <dxi-column dataField="image"
               cssClass="p-0"
               alignment="center"
               [allowHeaderFiltering]="false"
               [allowFiltering]="false" caption="Immagine"
               cellTemplate="imageTemplate"></dxi-column>
   <div *dxTemplate="let item of 'imageTemplate'">
      <button (click)="openImage(item.data)">
         <img *ngIf="item.data.image"
              [src]="openLink(item.data.image)" alt="image"
              class="h-12" style="max-width: 100%; margin: auto">

         <div *ngIf="!item.data.image">
            <i class="fa-2x fal fa-image"></i>
         </div>
      </button>
   </div>

   <dxi-column dataField="prodotto__brand__name" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Brand"></dxi-column>
   <dxi-column dataField="prodotto__nome" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Nome"></dxi-column>
   <dxi-column dataField="prodotto__codice" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Codice"></dxi-column>
   <dxi-column dataField="prodotto__colore_str" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Colore"></dxi-column>
   <dxi-column dataField="prodotto__year" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Anno"></dxi-column>
   <dxi-column *ngIf="!isModal" dataField="prodotto__stagione" caption="Stagione" [allowHeaderFiltering]="false" [allowFiltering]="true" width="80"></dxi-column>
   <dxi-column *ngIf="!isModal" dataField="prodotto__target_sesso" caption="Sesso" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
   <dxi-column *ngIf="!isModal" dataField="prodotto__target_eta" caption="Età" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
<!--   <dxi-column dataField="prodotto__stagione" caption="Stagione" cellTemplate="stagioneTemplate" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>-->
<!--   <div *dxTemplate="let cellInfo of 'stagioneTemplate'">-->
<!--      <div *ngFor="let st of Prodotto.STAGIONI">-->
<!--         <span *ngIf="st.value == cellInfo.data.prodotto__stagione">{{st.display}}</span>-->
<!--      </div>-->
<!--   </div>-->
<!--   <dxi-column dataField="prodotto__target_sesso" caption="Target Sesso" cellTemplate="sessoTemplate" [allowFiltering]="false"></dxi-column>-->
<!--   <div *dxTemplate="let cellInfo of 'sessoTemplate'">-->
<!--      <div *ngFor="let st of Prodotto.TARGET_SESSO">-->
<!--         <span *ngIf="st.value == cellInfo.data.prodotto__target_sesso" >{{st.display}}</span>-->
<!--      </div>-->
<!--   </div>-->
<!--   <dxi-column dataField="prodotto__target_eta" caption="Target Età" cellTemplate="etaTemplate" [allowFiltering]="false"></dxi-column>-->
<!--   <div *dxTemplate="let cellInfo of 'etaTemplate'">-->
<!--      <div *ngFor="let st of Prodotto.TARGET_ETA">-->
<!--         <span *ngIf="st.value == cellInfo.data.prodotto__target_eta">{{st.display}}</span>-->
<!--      </div>-->
<!--   </div>-->
   <dxi-column dataField="ean" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="EAN"></dxi-column>
   <dxi-column dataField="sku" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="SKU"></dxi-column>
   <dxi-column *ngIf="!isModal" dataField="metrica_1_nome" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Tabella taglie 1"></dxi-column>
   <dxi-column dataField="metrica_1_val" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Metrica 1"></dxi-column>
   <dxi-column *ngIf="!isModal" dataField="metrica_2_nome" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Tabella taglie 2"></dxi-column>
   <dxi-column dataField="metrica_2_val" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Metrica 2"></dxi-column>
   <dxi-column dataField="prezzo_listino_base" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Prezzo listino base" alignment="right" dataType="number" [format]="{style:'currency', currency:'EUR', precision:2}"></dxi-column>
   <dxi-column dataField="prezzo_listino" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Prezzo listino" alignment="right" dataType="number" [format]="{style:'currency', currency:'EUR', precision:2}"></dxi-column>

</dx-data-grid>

<!--<app-image-zoom [myFullresImage]="imageSel" (clickCloseDialog)="clickClose()"></app-image-zoom>-->
